import React from "react";
import moment from "moment";
import { ActionTimelineStyled } from "./styled";

// items: [{ key, label, color, created_at, note }]
const ActionTimeline = ({ title = "ประวัติการดำเนินการ (Timeline)", items }) => {
  return (
    <ActionTimelineStyled>
      <div className="timeline_title">{title}</div>
      <div className="timeline_wrap">
        {items && items.length > 0 ? (
          items.map((e, i) => (
            <div className="timeline_item" key={e.key || i}>
              <span
                className="timeline_dot"
                style={{ background: e.color }}
              />
              <div className="timeline_body">
                <div className="timeline_action" style={{ color: e.color }}>
                  {e.label}
                </div>
                <div className="timeline_meta">
                  {moment(e.created_at).format("DD/MM/YYYY HH:mm")}
                </div>
                {e.note && (
                  <div className="timeline_note">หมายเหตุ: {e.note}</div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="timeline_empty">ยังไม่มีประวัติการดำเนินการ</div>
        )}
      </div>
    </ActionTimelineStyled>
  );
};

export default ActionTimeline;
